module.exports = __webpack_public_path__ + "img/feedback-header.7de3ea5d.svg";